export default __webpack_public_path__ + "static/media/Spear of Ishti.d225962b.jpg";